
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Dictionary } from 'vue-router/types/router'
import { Route } from 'vue-router'
import { setToken, setType } from '@/utils/cookies'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'Jump',
  components: {}
})
export default class extends Vue {
  private redirect?: string
  private otherQuery: Dictionary<string> = {}
  private token: string = ''
  private type: string = ''

  @Watch('$route', { immediate: true })
  private onRouteChange (route: Route) {
    const query = route.query as Dictionary<string>
    // console.log(route, 'route')
    // setToken(route.query.token as string)
    // debugger
    // this.init()
    if (query) {
      this.redirect = query.redirect
      this.otherQuery = this.getOtherQuery(query)
    }
  }

  private getOtherQuery (query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur]
      }
      return acc
    }, {} as Dictionary<string>)
  }

  private init () {
    this.type = this.$route.query.enterprise_type as string
    setType(this.type)
    this.token = this.$route.query.token as string
    if (this.type === 'ant') {
      UserModule.SetAntToken(this.token)
    }
    UserModule.SetToken(this.token)
    this.$router.push(
      {
        path: '/enterpriseApp' || this.redirect,
        query: this.otherQuery
      },
      () => {},
      () => {}
    )
  }

  created () {
    this.init()
  }
}
